import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import contractService from '../../../utils/contractService';

const QuickStatsBar = () => {
  const [stats, setStats] = useState([
    {
      label: "Total Contracts",
      value: "0",
      icon: "FileText",
      color: "primary"
    },
    {
      label: "Success Rate",
      value: "100%",
      icon: "TrendingUp",
      color: "success"
    },
    {
      label: "Avg Processing Time",
      value: "Real-time",
      icon: "Clock",
      color: "secondary"
    },
    {
      label: "System Status",
      value: "AI Ready",
      icon: "CheckCircle",
      color: "success"
    }
  ]);

  // Load real contract statistics
  useEffect(() => {
    const loadStats = async () => {
      try {
        const result = await contractService.getContractStats();
        if (result.success) {
          const contractStats = result.data;
          const successRate = contractStats.total > 0 
            ? Math.round((contractStats.processed / contractStats.total) * 100)
            : 100;

          setStats([
            {
              label: "Total Contracts",
              value: contractStats.total.toString(),
              icon: "FileText",
              color: "primary"
            },
            {
              label: "Success Rate",
              value: `${successRate}%`,
              icon: "TrendingUp",
              color: "success"
            },
            {
              label: "This Month",
              value: contractStats.thisMonth.toString(),
              icon: "Calendar",
              color: "secondary"
            },
            {
              label: "System Status",
              value: "AI Ready",
              icon: "CheckCircle",
              color: "success"
            }
          ]);
        }
      } catch (error) {
        console.error('Error loading stats:', error);
        // Keep default stats on error
      }
    };

    loadStats();
  }, []);

  const getColorClasses = (color) => {
    switch (color) {
      case 'success':
        return {
          text: 'text-success',
          icon: 'var(--color-success)'
        };
      case 'secondary':
        return {
          text: 'text-secondary',
          icon: 'var(--color-secondary)'
        };
      default:
        return {
          text: 'text-primary',
          icon: 'var(--color-primary)'
        };
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 shadow-card">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-6">
        {stats.map((stat, index) => {
          const colorClasses = getColorClasses(stat.color);
          
          return (
            <div key={index} className="flex items-center space-x-4 min-w-0">
              <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon 
                  name={stat.icon} 
                  size={24} 
                  color={colorClasses.icon}
                  strokeWidth={2}
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-body font-medium text-muted-foreground">
                  {stat.label}
                </div>
                <div className={`text-lg sm:text-xl font-heading font-semibold ${colorClasses.text} truncate`}>
                  {stat.value}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuickStatsBar;